export default "__VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__ 560w, __VITE_ASSET__gOpBNSELCNdnM_yZlyA5OQ__ 1152w, __VITE_ASSET__ZoP2ebLT5e$hm8jPkF9mgA__ 2304w";